import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2"; 
import { useNavigate } from "react-router-dom"; // ⬅️ import this at the top

const ApproveListingDetail = () => {
  const { id } = useParams();
  const [listing, setListing] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchListingDetails = async () => {
      try {
        const response = await axios.get(`${baseurl}getSellerListingById/${id}`);
        if (response.data.success) {
          setListing(response.data.data);
        }
      } catch (error) {
        console.error("❌ Error fetching listing:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchListingDetails();
  }, [id]);

  const displayMapping = {
    seller_first_name: "Seller First Name",
    seller_last_name: "Seller Last Name",
    title: "Product Title",
    condition: "Condition",
    type: "Listing Type",
    price: "Selling Price",
    currency: "Currency",
    quantity: "Available Quantity",
    description: "Product Description",
    listingstandard: "Unit Standard",
    warranty: "Warranty",
    return_policy: "Return Policy",
    standard_delivery_charge: "Standard Delivery Charge",
    delivery_method: "Delivery Method",
    gst: "GST (%)",
    status: "Listing Status",
    created_at: "Created At",
  };





const navigate = useNavigate(); // ⬅️ initialize this inside your component

const handleApprove = async () => {
  try {
    const result = await Swal.fire({
      title: "Approve Listing?",
      text: "Are you sure you want to approve this listing?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve",
    });

    if (result.isConfirmed) {
      const res = await axios.post(`${baseurl}approveSellerListing`, { id });
      if (res.data.success) {
        Swal.fire("Success", "Listing approved successfully!", "success").then(() => {
          setListing({ ...listing, status: "approved" }); // ✅ Update UI
          navigate(-1); // ⬅️ Navigate back
        });
      } else {
        Swal.fire("Error", "Failed to approve listing", "error");
      }
    }
  } catch (error) {
    console.error("❌ Error approving listing:", error);
    Swal.fire("Error", "Something went wrong", "error");
  }
};



const handleReject = async () => {
  try {
    const result = await Swal.fire({
      title: "Reject Listing?",
      text: "Are you sure you want to reject this listing?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reject",
    });

    if (result.isConfirmed) {
      const res = await axios.post(`${baseurl}rejectSellerListing`, { id });
      if (res.data.success) {
        Swal.fire("Success", "Listing rejected successfully!", "success").then(() => {
          setListing({ ...listing, status: "rejected" }); // ✅ Update UI
          navigate(-1); // ⬅️ Navigate back
        });
      } else {
        Swal.fire("Error", "Failed to reject listing", "error");
      }
    }
  } catch (error) {
    console.error("❌ Error rejecting listing:", error);
    Swal.fire("Error", "Something went wrong", "error");
  }
};




  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container text-start">
          <h4 className="mb-4">Seller Listing Details</h4>

          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "200px" }}
            >
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          ) : listing ? (
            <div className="card text-start">
              <div className="card-body">
                {Object.entries(displayMapping).map(([key, label]) => (
                  <div className="row mb-3" key={key}>
                    <label className="col-sm-3 fw-bold text-dark">{label}</label>
                    <div className="col-sm-9">
                      {key === "description" ? (
                        <div
                          className="form-control"
                          dangerouslySetInnerHTML={{ __html: listing[key] || "N/A" }}
                        />
                      ) : (
                        <div className="form-control">
                          {key === "created_at"
                            ? new Date(listing[key]).toLocaleString()
                            : listing[key] || "N/A"}
                        </div>
                      )}
                    </div>
                  </div>
                ))}

                {/* Category Hierarchy Display */}
                <div className="row mb-3">
                  <label className="col-sm-3 fw-bold text-dark">Category Hierarchy</label>
                  <div className="col-sm-9">
                    <div className="form-control">
                      {listing.category_titles && listing.category_titles.length > 0 ? (
                        <ul className="mb-0 ps-3">
                          {listing.category_titles.map((title, index) => (
                            <li key={index}>{title}</li>
                          ))}
                        </ul>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>
                </div>

                {/* Image Gallery Display */}
                <div className="row mb-3">
                  <label className="col-sm-3 fw-bold text-dark">Product Images</label>
                  <div className="col-sm-9">
                    <div className="d-flex flex-wrap gap-2">
                      {listing.images && listing.images.length > 0 ? (
                        listing.images.map((img) => (
                          <div key={img.id} style={{ width: "120px" }}>
                            <img
                              src={`${imageUrl}listing/${img.listing_image}`}
                              alt="listing"
                              className="img-fluid rounded"
                            />
                          </div>
                        ))
                      ) : (
                        <div className="form-control">No images found.</div>
                      )}
                    </div>
                  </div>
                </div>



<div className="d-flex">
{listing?.status === "pending" && (
  <div className="text-end me-3">
    <button className="btn btn-primary" onClick={handleApprove}>
      Approve Listing
    </button>
  </div>
)}


{listing?.status === "pending" && (
  <div className="text-end">
    <button className="btn btn-warning" onClick={handleReject}>
      Reject Listing
    </button>
  </div>
)}



{listing?.status === "approved" && (
  <div className="text-end">
    <button className="btn btn-warning" onClick={handleReject}>
      Reject Listing
    </button>
  </div>
)}



</div>
                





              </div>
            </div>
          ) : (
            <div className="alert alert-warning">Listing not found.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ApproveListingDetail;
